export default __webpack_public_path__ + "static/media/SmartClassKit_Controller.b4b29ea8.nproj";